import { ref, set, remove } from 'firebase/database';
import { db, getEnvDbPrefix } from '@/core/firebase/config';
import { hashToken, detectPlatform } from '@/features/notifications/utils/token';
import { useCallback } from 'react';

/**
 * Hook that provides functions to save or remove an FCM token
 * in the user's notifications/fcmTokens path.
 */
export default function useSaveNotificationToken() {
  const saveToken = useCallback(async (userId: string, token: string) => {
    const tokenHash = await hashToken(token);
    const dbPath = getEnvDbPrefix(`user/${userId}/notifications/fcmTokens/${tokenHash}`);
    const tokenRef = ref(db, dbPath);

    await set(tokenRef, {
      token,
      createdAt: new Date().toISOString(),
      platform: detectPlatform(),
    });
  }, []);

  const removeToken = useCallback(async (userId: string, token: string) => {
    const tokenHash = await hashToken(token);
    const dbPath = getEnvDbPrefix(`user/${userId}/notifications/fcmTokens/${tokenHash}`);
    const tokenRef = ref(db, dbPath);

    await remove(tokenRef);
  }, []);

  return { saveToken, removeToken };
}
